import { css } from '@/styled-system/css';

export const alertCloseStyles = css.raw({
  flex: '0',
  marginBlockStart: `calc(-1 * {spacing.default})`,
  marginInlineEnd: `calc(-1 * {spacing.default})`,
  marginInlineStart: 'default',
  paddingBlockStart: 'Alert.CloseButton.margin.top',
  paddingInlineEnd: 'Alert.CloseButton.margin.right',
});
